const FoodExpense = {
    "1": {
      "Female": {
        "1 - 3 years": 2.75,
        "4 - 8 years": 3.72,
        "9 - 13 years": 6.1,
        "14 - 50 years": 6.57,
        "51 - 69 years": 6.59,
        "70+ years": 6.96
      },
      "Male": {
        "1 - 3 years": 2.75,
        "4 - 8 years": 3.72,
        "9 - 13 years": 6.1,
        "14 - 50 years": 7.36,
        "51 - 69 years": 6.99,
        "70+ years": 6.96
      },
    },
    "2": {
      "Female": {
        "1 - 3 years": 2.5,
        "4 - 8 years": 3.38,
        "9 - 13 years": 5.52,
        "14 - 50 years": 5.97,
        "51 - 69 years": 5.99,
        "70+ years": 6.33
      },
      "Male": {
        "1 - 3 years": 2.5,
        "4 - 8 years": 3.38,
        "9 - 13 years": 5.52,
        "14 - 50 years": 6.69,
        "51 - 69 years": 6.35,
        "70+ years": 6.33
      }
    },
    "3": {
      "Female": {
        "1 - 3 years": 2,
        "4 - 8 years": 2.7,
        "9 - 13 years": 4.42,
        "14 - 50 years": 4.78,
        "51-60 years": 4.79,
        "70+ years": 5.06
      },
      "Male": {
        "1 - 3 years": 2,
        "4 - 8 years": 2.7,
        "9 - 13 years": 4.42,
        "14 - 50 years": 5.35,
        "51 - 69 years": 5.08,
        "70+ years": 5.06
      }
    },
    "4": {
      "Female": {
        "1 - 3 years": 1.75,
        "4 - 8 years": 2.37,
        "9 - 13 years": 3.86,
        "14 - 50 years": 4.18,
        "51 - 69 years": 4.19,
        "70+ years": 4.43
      },
      "Male": {
        "1 - 3 years": 1.75,
        "4 - 8 years": 2.37,
        "9 - 13 years": 3.86,
        "14 - 50 years": 4.68,
        "51 - 69 years": 4.45,
        "70+ years": 4.43
      }
    }
  };
  export default FoodExpense;
  